import { getBrowserSessionId } from "@/lib/browser-session-id";

const STORAGE_KEY = "repackify.guest-checkout-session";

export function getGuestCheckoutSessionId(): string {
  return getBrowserSessionId(STORAGE_KEY);
}
